module.exports = __webpack_public_path__ + "272bb70478d0d2c7fc9b4d6c948b5f18.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-ThinItalic.ttf
// module id = 1265
// module chunks = 0